import { useState } from "react";
import { toast } from "sonner";
import { Ban, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { apiError, brl } from "@/lib/format";

const REFUND_LABEL = { REQUESTED: ["Reembolso solicitado — em análise", "text-amber-300"], APPROVED: ["Cancelamento aprovado", "text-emerald-300"], REJECTED: ["Pedido de cancelamento recusado", "text-red-300"] };

export const RefundRequest = ({ reg, onDone }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const elig = reg.refund_eligibility || {};

  if (reg.refund) {
    const [label, cls] = REFUND_LABEL[reg.refund.status] || [reg.refund.status, ""];
    return <span data-testid={`refund-status-${reg.bib_code}`} className={`inline-flex items-center text-xs font-bold self-center ${cls}`}>{label}</span>;
  }
  if (reg.status === "CANCELLED") return null;

  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/me/registrations/${reg.id}/refund-request`, { reason });
      toast.success(elig.refundable ? "Solicitação enviada! A organização responderá por e-mail." : "Inscrição cancelada.");
      setOpen(false); onDone?.();
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button data-testid={`refund-btn-${reg.bib_code}`} variant="ghost" onClick={() => elig.eligible ? setOpen(true) : toast.error(elig.reason)}
        className={`border border-white/10 text-xs font-bold uppercase ${elig.eligible ? "text-red-300 hover:bg-red-500/10" : "text-slate-500"}`}>
        <Ban className="w-4 h-4 mr-2" /> {reg.status === "PAID" ? "Solicitar cancelamento" : "Cancelar inscrição"}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-surface border-white/10 text-white max-w-md" data-testid="refund-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl uppercase">Cancelar inscrição</DialogTitle></DialogHeader>
          <div className="space-y-3 text-sm text-slate-300">
            {elig.refundable ? (
              <p>Conforme o <b>Art. 5º do Regulamento</b>, você tem direito ao reembolso integral de <b className="text-neon">{brl(reg.category?.price)}</b> por estar dentro do prazo de 7 dias após a confirmação do pagamento{elig.deadline ? ` (até ${new Date(elig.deadline).toLocaleDateString("pt-BR")})` : ""}. A organização analisará e responderá por e-mail.</p>
            ) : (
              <p>Sua inscrição ainda não foi paga. Ela será cancelada imediatamente e a vaga liberada.</p>
            )}
            <Textarea data-testid="refund-reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivo (opcional)" className="bg-ink border-white/10" />
            <div className="flex gap-2 justify-end">
              <Button variant="ghost" onClick={() => setOpen(false)} className="border border-white/10">Voltar</Button>
              <Button data-testid="refund-confirm-btn" onClick={submit} disabled={busy} className="bg-red-600 hover:bg-red-700 font-bold uppercase">
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Confirmar"}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RefundRequest;
